import { render } from "./AssetLibrary.vue?vue&type=template&id=3df9e3d1&scoped=true"
import script from "./AssetLibrary.vue?vue&type=script&lang=js"
export * from "./AssetLibrary.vue?vue&type=script&lang=js"

import "./AssetLibrary.vue?vue&type=style&index=0&id=3df9e3d1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3df9e3d1"]])

export default __exports__